export default {"src":"/_next/static/media/google-login-icon.1131f191.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};